<button id="PriceVerifyModal_Button_Close" aria-label="Close" class="close" data-dismiss="modal" tabindex="-1" type="button" (click)="closeModal()">
  <span aria-hidden="true">&times;</span>
</button>
<div class="modal-header"><div class="modal-title"></div></div>
<div class="modal-body">
  <div class='price-verify-payer'>
    <b>Verify or edit the account number below.</b>
    @let vm = {selectedRewardNumber: selectedRewardNumber$ | async};
    <form style="text-align:left; width:50%; margin:10px auto;">
      <div class="form-group">
        <label for="PriceVerifyModal_Text_PayerCardNumber">Payer Card Number</label>
        <input id="PriceVerifyModal_Text_PayerCardNumber" class="form-control rush-form-control" name="PriceVerifyModal_Text_PayerCardNumber" #txtmscCardNo [(ngModel)]="payerCardNumber">
        @if (!payerCardNumber) {
          <div class="text-danger">
            Payer Card Number is required.
          </div>
        }
      </div>
      <button
        id="PriceVerifyModal_Button_Continue"
        type="submit"
        class="btn btn-default yellow-btn"
        (click)="priceVerification(vm.selectedRewardNumber)"
        [disabled]="loading || !payerCardNumber">
        Continue
      </button>
    </form>
  </div>
</div>
